module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-50-Classes-Inactive-66c34fb0e5681f638c7608441e0ceac3.png";